module.exports = __webpack_public_path__ + "static/media/lc50.9dd86418.mp3";